export class HeaderTitle {
  name: string;

  constructor(name: string) {
    this.name = name;
  }
}
